import { render, staticRenderFns } from "./ParticulaMagneticaModal.vue?vue&type=template&id=222ec92d&scoped=true"
import script from "./ParticulaMagneticaModal.vue?vue&type=script&lang=js"
export * from "./ParticulaMagneticaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222ec92d",
  null
  
)

export default component.exports